import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches payment plans from the API
 *
 * @returns {Promise<import('../types/PaymentPlan.api').IGetPaymentPlansApiResponse>} Payment plans API response
 */
export const getPaymentPlans = async () => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get('/payment/admin/plans', {
    headers,
  });

  return response.data;
};
